import { ArrowRight, Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useI18n } from "@/lib/i18n";
import { normalizeLanguageCode } from "@/lib/languages";

export default function LinkedAuthLanguageStep({
  formError = "",
  homeLanguageCode = "",
  isBusy = false,
  languageOptions = [],
  locale = "",
  onContinue,
  onHomeLanguageChange,
  onUnderstoodLanguageChange,
  otherLanguageOptions = [],
  submitting = false,
  understoodLanguageCodes = [],
}) {
  const { t, tx } = useI18n();
  return (
    <div className="space-y-5">
      <p className="text-sm text-muted-foreground">{t("auth.language_copy")}</p>
      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground" htmlFor="home-language">
          {t("auth.home_language")}
        </label>
        <Select
          value={normalizeLanguageCode(homeLanguageCode || locale)}
          onValueChange={onHomeLanguageChange}
        >
          <SelectTrigger id="home-language" className="h-12 rounded-2xl text-base">
            <SelectValue placeholder={t("auth.home_language")} />
          </SelectTrigger>
          <SelectContent>
            {languageOptions.map((language) => (
              <SelectItem key={language.code} value={language.code}>
                {language.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-3">
        <div>
          <div className="text-sm font-medium text-foreground">{t("auth.other_languages")}</div>
          <p className="mt-1 text-sm text-muted-foreground">{t("auth.other_languages_help")}</p>
        </div>
        <div className="rounded-2xl border border-border/70 bg-muted/30 p-3">
          <div className="grid gap-3">
            {otherLanguageOptions.map((language) => {
              const checked = understoodLanguageCodes.includes(language.code);
              return (
                <label
                  key={language.code}
                  className="flex items-center justify-between gap-3 rounded-xl px-1 py-1 text-sm text-foreground"
                >
                  <span>{language.label}</span>
                  <Checkbox
                    checked={checked}
                    onCheckedChange={(nextChecked) => onUnderstoodLanguageChange(language.code, nextChecked)}
                  />
                </label>
              );
            })}
          </div>
        </div>
      </div>
      <Button
        type="button"
        size="lg"
        className="h-14 w-full rounded-2xl text-base font-semibold"
        onClick={onContinue}
        disabled={isBusy}
      >
        {submitting ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />
            {tx("Saving…")}
          </>
        ) : (
          <>
            {t("auth.continue_with_language")} <ArrowRight className="h-4 w-4" />
          </>
        )}
      </Button>
      {formError ? <p className="text-sm text-destructive">{tx(formError)}</p> : null}
    </div>
  );
}
